import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/PaymentStyles.scss';

const PaymentCancelled: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="page-payment">
            <div className="payment-container cancelled">
                <i className="fas fa-times-circle icon-cancelled"></i>
                <h2>Payment Cancelled</h2>
                <p>You have cancelled the checkout process. No charges were made.</p>
                <button className="btn-primary" onClick={() => navigate('/')}>
                    Return to Dashboard
                </button>
            </div>
        </div>
    );
};

export default PaymentCancelled;
